// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getCategoriasPOI as listCategoriasPOIAPI,
    getCategoriaPOI as getCategoriaPOIAPI,
    addCategoriaPOI as addCategoriaPOIAPI,
    updateCategoriaPOI as updateCategoriaPOIAPI,
    deleteCategoriaPOI as deleteCategoriaPOIAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { categoriasPOIApiResponseError, categoriasPOIApiResponseSuccess } from './actions';
import { CategoriasPOIActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getCategoriaPOI({ payload: { id } }) {
    try {
        const response = yield call(getCategoriaPOIAPI, id );
        const categoriaItem = response.data.data;
        yield put(categoriasPOIApiResponseSuccess(CategoriasPOIActionTypes.GET_CATEGORIA_POI, categoriaItem));
    } catch (error) {
        yield put(categoriasPOIApiResponseError(CategoriasPOIActionTypes.GET_CATEGORIA_POI, error));
    }
}

function* addCategoriaPOI({payload:categoria}){
    try{
        const response = yield call(addCategoriaPOIAPI,{...categoria})
        const categoriaItem = response.data
        yield put(categoriasPOIApiResponseSuccess(CategoriasPOIActionTypes.ADD_CATEGORIA_POI,categoriaItem))
    } catch(error){
        yield put(categoriasPOIApiResponseError(CategoriasPOIActionTypes.ADD_CATEGORIA_POI,error))
    }
}

function* updateCategoriaPOI({payload:categoria}){
    try{
        const response = yield call(updateCategoriaPOIAPI,{...categoria})
        const categoriaItem = response.data.data
        yield put(categoriasPOIApiResponseSuccess(CategoriasPOIActionTypes.UPDATE_CATEGORIA_POI,categoriaItem))
    }catch(error){
        yield put(categoriasPOIApiResponseError(CategoriasPOIActionTypes.UPDATE_CATEGORIA_POI,error))
    }
}
function* deleteCategoriaPOI({payload:{id}}){
    try{
        const response = yield call(deleteCategoriaPOIAPI,id)
        const categoriaItem = response.data.id
        yield put(categoriasPOIApiResponseSuccess(CategoriasPOIActionTypes.DELETE_CATEGORIA_POI,categoriaItem))
    }catch(error){
        yield put(categoriasPOIApiResponseError(CategoriasPOIActionTypes.DELETE_CATEGORIA_POI,error))
    }
}

/**
 * List contactos
 */
function* listCategoriasPOI({payload:params}) {
    try {
        const response = yield call(listCategoriasPOIAPI, { ...params });
        const listaCategorias = response.data.data;
        yield put(categoriasPOIApiResponseSuccess(CategoriasPOIActionTypes.LIST_CATEGORIAS_POI, listaCategorias));
    } catch (error) {
        yield put(categoriasPOIApiResponseError(CategoriasPOIActionTypes.LIST_CATEGORIAS_POI, error));
    }
}


export function* watchGetCategoriaPOI(): any {
    yield takeEvery(CategoriasPOIActionTypes.GET_CATEGORIA_POI, getCategoriaPOI);
}

export function* watchListCategoriasPOI(): any {
    yield takeEvery(CategoriasPOIActionTypes.LIST_CATEGORIAS_POI, listCategoriasPOI);
}

export function* watchAddCategoriaPOI():any{
    yield takeEvery(CategoriasPOIActionTypes.ADD_CATEGORIA_POI,addCategoriaPOI)
}
export function* watchUpdateCategoriaPOI():any{
    yield takeEvery(CategoriasPOIActionTypes.UPDATE_CATEGORIA_POI,updateCategoriaPOI)
}
export function* watchDeleteCategoriaPOI():any{
    yield takeEvery(CategoriasPOIActionTypes.DELETE_CATEGORIA_POI,deleteCategoriaPOI)
}


function* categoriasPOISaga(): any {
    yield all([
        fork(watchGetCategoriaPOI),
        fork(watchListCategoriasPOI),
        fork(watchAddCategoriaPOI),
        fork(watchUpdateCategoriaPOI),
        fork(watchDeleteCategoriaPOI),
    ]);
}

export default categoriasPOISaga;
